<template>
    <button :disabled="disabled" class="btn" @click='$emit("click")'>
        <slot></slot>
    </button>
</template>

<script>
export default {
  name: 'Button',
    props: {
        disabled: {
            type: Boolean
        }
    }
};
</script>

